import { Hourglass } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";
import type { ChatStreamState } from "./chatStreamReducer";

/** Shown while the reply waits out a provider rate limit; it goes when the retry starts (MHS-715). */
export function CapacityWaitNotice({ wait }: Readonly<{ wait: NonNullable<ChatStreamState["capacityWait"]> }>) {
  const { t } = useTranslation("chat");
  const seconds = wait.retryAfterSeconds === null ? null : Math.max(1, Math.round(wait.retryAfterSeconds));
  return (
    <output className="flex items-center gap-2">
      <Hourglass size={14} aria-hidden="true" className="text-content-tertiary" />
      <Text as="span" tone="warning">
        {seconds === null ? t("reply.waitingForCapacityUnknown") : t("reply.waitingForCapacity", { count: seconds })}
      </Text>
    </output>
  );
}
